import { useSettingsContext } from '@/contexts/SettingsContext'

export const useSettings = () => useSettingsContext()
